import { Component, OnInit } from '@angular/core';
import { ContextMenuComponent, MenuEvent } from '@progress/kendo-angular-menu';
import { AuthenticationService, AuthenticatedUser, Permission } from 'projects/lib_authentication/src/public-api';
import { ApplicationSettings } from 'projects/lib_config/src/public-api';
import { ManagedUser, UserService } from 'projects/lib_util/src/public-api';

@Component({
    selector: 'spv2-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class LayoutComponent implements OnInit {
  user: AuthenticatedUser;
  permission = Permission;
  opened = false;

  showNoAccessBanner = false;

  currentYear = new Date().getFullYear();

  constructor(private authService: AuthenticationService, private userService: UserService, public settings: ApplicationSettings) { }

  async ngOnInit() {
    this.loadCookieScript();
    this.user = await this.authService.getAuthenticadedUserObservable().toPromise();
    this.authService.getRolesAndPermissionsObservable().subscribe(async x => {
      this.showNoAccessBanner = !x?.hasElevatedRoleOrCompanyAccess();
      if(!x.hasApplicationRole()) {
        var user = await this.authService.getAuthenticadedUserObservable().toPromise();
        //if user is not known by the application, create it
        await this.userService.createBasicUser(new ManagedUser(this.settings.policyServiceAppId, user.email, user.firstName, user.lastName, 3 /*User role*/)).toPromise();
      };
    });
  }

  //Method used to show cookie banner, normally we would not load scripts like this.
  loadCookieScript() {
    let node = document.createElement('script'); // creates the script tag
    node.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"; 
    node.type = 'text/javascript'; // set the script type
    node.async = true; // makes script run asynchronously
    node.charset = "UTF-8"
    node.setAttribute("data-domain-script", "389b873b-65d7-46b3-959e-3b77fdb3b230" + (this.settings.production ? "" : "-test"))

    // append to head of document
    document.getElementsByTagName('head')[0].appendChild(node); 
  }

  showContextMenu(contextMenu: ContextMenuComponent, element: HTMLElement, elementToTakeWidthFrom: HTMLElement) {
    contextMenu.show({ left: elementToTakeWidthFrom.offsetLeft + elementToTakeWidthFrom.offsetWidth, top: element.offsetTop + (element.offsetHeight * 2) });
  }

  logout(){
    this.authService.logoff();
  }

  toggleMenu() {
    this.opened = !this.opened;
  }

  closeMenu() {
    this.opened = false;
  }

  async tempRemoveApplicationPermissions() {
    await this.authService.tempRemoveApplicationPermissions();
  }

  onSelectContextItme(event: MenuEvent): void {
    event.item.click();
  }
}
